sai-result<!--首页-->
<template>

  <div class="box">
    <div class="top-box">
      <div class="title">{{row.name}}</div>
      <van-dropdown-menu>
        <van-dropdown-item v-model="params.subject" :options="options" @change="subjectChange" >
        </van-dropdown-item>
      </van-dropdown-menu>
    </div>
    <div style="height:2.3rem"></div>
    <div class="activity-list" v-for="(subjectGroup,i) in list" :key="i" v-show="subjectGroup.list.length>0">
      <div class="activity-list-title-box">
        <div class="title-left-solid"></div>
        <div class="activity-title">{{subjectGroup.sub_subject_name}}</div>
      </div>
      <div class="list-team">
        <div class="team-item" v-for="(item,i2) in subjectGroup.list" :key="i2">
          <div class="team-rank">
            <div :class="'team-rank-num rank-change'+(item.rank-1)" v-if="(item.rank-1)<3">{{item.rank}}.</div>
            <div class="team-rank-num rank-no" v-else>{{i2+1}}</div>

          </div>
          <div class="team-info">
            <div class="team-info-name">{{item.mingcheng}}</div>
            <div class="team-info-grande"><em>{{item.score_total}}</em>分</div>
          </div>
        </div>

        <div></div>
      </div>
    </div>


  </div>


</template>
<style scoped>
  /* @import '../../assets/style/index.css'; */
  .dropdown-item-option-title{
    height: 30px;
    line-height: 30px;
    margin-top: 5px;
    text-align: center;
    border-bottom: 1px solid #efefef;
  }
  .rank-change0{
    color: #F5A623;
    font-size:20px;
  }
  .rank-change1{
    color: #9B9B9B;
    font-size:20px;
  }
  .rank-change2{
    color: #D0021B;
    font-size:20px;
  }
  .rank-no{
    font-size: 16px;
    color: #333333;
  }
  .team-rank-num{
    height:20px;
    width: 20px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    line-height:20px;
    text-align: left;
    margin-right: 10px;
  }
  .team-info-grande{
    height:17px;
    font-size:12px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    line-height:17px;
  }
  .team-info-grande em{
    color:#F5A623;
    font-weight: bold;
    font-size: 18px;
  }
  .team-info-name{
    /*height:20px;*/
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(0,0,0,0.85);
    line-height:20px;
  }
  .team-item{width: 100%;display: flex;margin: 20px 0;}
  .list-team{
    width: 90%;
    margin: 0 auto;
  }
  .activity-title{
    height:20px;font-size:14px;font-family:PingFangSC-Medium,PingFang SC;font-weight:500;color:rgba(0,0,0,0.85);line-height:20px;
  }
  .activity-list{
    width: 6.9rem;padding: 5px;margin: 0 auto;margin-top: 13px;border-radius: 10px;background: #fff;
  }
  .title-left-solid{
    width:4px;height:15px;background:rgba(208,2,27,1);border-radius:2px;margin: 0 11px 0 5px;
  }
  .activity-list-title-box{
    width: 100%;height: 1.2rem;border-bottom: 1px solid rgba(0,0,0,0.1);display: flex;align-items: center;
  }
  .top-box{
    height: 2.21rem;width: 100%;background: #fff;border-radius: 0 0 10px 10px; 
    position: fixed;top: 0;
  }
  .top-box >>> [class*=van-hairline]::after{border: none;}

  .title{
    width:100%;
    font-size:19px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(0,0,0,1);
    line-height:26px;
    text-align: center;
    margin:10px 0 10px ;
  }
  .box {
    background: #F8F8F8;
    padding-bottom: 50px;
    /* overflow: hidden; */
  }



</style>

<script>
  import Vue from 'vue';
  import { DropdownMenu, DropdownItem } from 'vant';

  Vue.use(DropdownMenu).use(DropdownItem);

  export default {
    name: 'QueryGrade',
    components: {

    },
    data: function () {
      return {
        active: 1,
        value: 1,
        value2:2,
        switch1: false,
        switch2: false,
        options: [
        ],
        params:{
          old:0,
          saiqu:0,
          subject:'',
        },
        row:{

        },
        list:[]


      }
    },
    filter: {},
    mounted() {
      document.title = '成绩查询';
      this.params.saiqu = this.$route.query.saiqu;
      this.params.old = this.$route.query.old;

       this.fetch()
    },
    destroyed() {
    },
    methods: {
      fetch(){
        let that = this;
        that.$api.get('/api/sai/results', that.params, (res) => {
          that.list = res.data.list
          that.row = res.data.row
          that.options = res.data.options
          that.params.subject = res.data.subject
        })
      },
      subjectChange(){
        this.fetch();
      },
      onConfirm() {
        this.$refs.item.toggle();
      },
      dropdownChange(item){
        console.log(item.value)
        this.value=item.value
      }

    }
  }
</script>



// WEBPACK FOOTER //
// SaiResult.vue?57d565ae